import { defineStore } from 'pinia'

import modelClass from '@models/member'
import * as getters from '@modelStores/helpers/getters-helper'

export const useMemberStore = defineStore('member-store', {
  state: () => {
    return {
      resources: []
    }
  },
  getters: {
    ...getters,
    modelClass: () => modelClass
  }
})
